// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DriverEarningsConfig from "./DriverEarningsConfig.bs.js";

var dummyWeeklySummaryEarningsResponse = {
      weekly_earning_summaries: [
        {
          total_earnings: 320.56,
          num_trips_completed: 10,
          start_date: "2019-03-01",
          end_date: "2019-03-07",
        },
        {
          total_earnings: 256.13,
          num_trips_completed: 10,
          start_date: "2019-03-15",
          end_date: "2019-03-18",
        },
      ]
    };

var dummyDailySummaryEarningsResponse = {
      weekly_earning_reports: [
        {
          daily_earning_reports: [
            {
              date: "2019-03-04",
              work_unit_earning_reports: [
                {
                  work_unit: {
                    type: "MBG",
                    entitlement_date: "2019-03-04",
                    default_title: "dummy_order",
                  },
                  total_earnings: 99.9,
                  total_cash_settlement: 65.37,
                  total_wallet_settlement: -57.28,
                },
                {
                  work_unit: {
                    type: "MBG",
                    entitlement_date: "2019-03-04",
                    default_title: "dummy_order",
                  },
                  total_earnings: 99.9,
                  total_cash_settlement: 100,
                  total_wallet_settlement: 200,
                },
              ],
            },
          ],
        },
      ]
    };

function fetchDriverEarningSummaries(msisdn, param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyWeeklySummaryEarningsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._2(DriverEarningsConfig.DriverEarningsResponseConverter.execute, result, msisdn);
                        });
            });
}

function fetchDriverDailyEarningDetails(msisdn, _date, param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyDailySummaryEarningsResponse
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._2(DriverEarningsConfig.DriverDailyEarningsResponseConverter.execute, result, msisdn);
                        });
            });
}

var DummyDriverEarningsRepo = {
  dummyWeeklySummaryEarningsResponse: dummyWeeklySummaryEarningsResponse,
  dummyDailySummaryEarningsResponse: dummyDailySummaryEarningsResponse,
  fetchDriverEarningSummaries: fetchDriverEarningSummaries,
  fetchDriverDailyEarningDetails: fetchDriverDailyEarningDetails
};

export {
  DummyDriverEarningsRepo ,
  
}
/* DriverEarningsConfig Not a pure module */
